// Our main CSS
import { forEach } from '@splidejs/splide/src/js/utils'
import '../css/app.css'
import { list } from 'postcss'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */

if (document.querySelector('.sidebar')) {
  import('./sidebar').then((module) => {
    module.default()
  })
}

if (document.querySelector('nav')) {
  import('./nav').then((module) => {
    module.default()
  })
}

if (document.querySelector('.splide')) {
  import('./splide').then((module) => {
    module.default()
  })
}

if (document.querySelector('.faq-btn, .filter-btn')) {
  import('./accordions').then((module) => {
    module.default()
  })
}

if (document.querySelector('.range-slider')) {
  import('./range-slider').then((module) => {
    module.default()
  })
}

if (document.querySelector('.apartment-stats-btn')) {
  import('./apartment-stats').then((module) => {
    module.default()
  })
}

const lightbox = document.querySelector('#lightbox')
if (lightbox) {
  import('./lightbox').then((module) => {
    module.default()
  })
}

const listBtn = document.querySelector('.toggle-view')
if (listBtn) {
  import('./list').then((module) => {
    module.default()
  })
}

const videoPlayBtns = document.querySelectorAll('.video-play-button')
if (videoPlayBtns) {
  import('./video').then((module) => {
    module.default()
  })
}

const logoMarquee = document.querySelector('.logo-marquee')
if (logoMarquee) {
  import('./logo-marquee').then((module) => {
    module.default()
  })
}

const kvartersvardar = document.getElementById(
  'kvartersvardar'
)
if (kvartersvardar && kvartersvardar !== null) {
  import('./kvartersvardar/index.js')
    .then((module) => {
      module.default(kvartersvardar as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const updateStreetOptions = () => {
  // Handle apartment stats form
  const areaSelect = document.getElementById('area') as HTMLSelectElement
  const streetSelect = document.getElementById('gata') as HTMLSelectElement

  if (areaSelect && streetSelect) {
    const updateOptions = () => {
      Array.from(streetSelect.options).forEach((option) => {
        // Check if option should be hidden based on area
        const shouldHide =
          option.hasAttribute('data-area') &&
          option.getAttribute('data-area') !== '' &&
          option.getAttribute('data-area') !== areaSelect.value

        option.hidden = shouldHide
      })
    }

    areaSelect.addEventListener('change', () => {
      streetSelect.value = ''
      updateOptions()
    })

    updateOptions()
  }

  // Handle search forms (apartment, carpark, storehouse)
  const searchForms = document.querySelectorAll('.apartment-search form, .carpark-search form, .storehouse-search form')

  searchForms.forEach(searchForm => {
    const streetSelect = searchForm.querySelector('#street') as HTMLSelectElement

    if (searchForm && streetSelect) {
      const areaCheckboxes = searchForm.querySelectorAll('input[name="areas[]"]') as NodeListOf<HTMLInputElement>

      const updateStreetOptions = () => {
        const selectedAreas = Array.from(areaCheckboxes)
          .filter(checkbox => checkbox.checked)
          .map(checkbox => checkbox.value)

        Array.from(streetSelect.options).forEach((option) => {
          if (option.value === '') return // Don't hide "Alla gator" option

          const streetArea = option.getAttribute('data-area')
          const shouldHide = selectedAreas.length > 0 &&
            streetArea !== null &&
            streetArea !== '' &&
            !selectedAreas.includes(streetArea)

          option.hidden = shouldHide
        })

        // Reset selection if current selection is now hidden
        if (streetSelect.selectedOptions[0]?.hidden) {
          streetSelect.value = ''
        }
      }

      areaCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateStreetOptions)
      })

      updateStreetOptions()
    }
  })
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', updateStreetOptions)

//Get height of the navbar
const navbar = document.getElementsByClassName('navbar')

if (navbar && !document.body.classList.contains('page-template-template-event')) {
  const navbarHeight = navbar.item(0)?.clientHeight
  document.body.style.paddingTop = navbarHeight + 'px'
}